import { BmHttp } from "../utils/Global";
import { notifyCitaFinalizada, CITA_FINALIZADA_SENTINEL } from "../utils/citaFinalizadaAlert";

export const guardarCertificadoPermisoService = async (examen) => {
  try {

    console.log(examen);
    const { data } = await BmHttp().post("certificado_permiso_orden", examen);
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    console.error(error);
  }
};
export const guardarCertificadoAsistenciaService = async (examen) => {
  try {
    const { data } = await BmHttp().post("certificado_asistencia_orden", examen);
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    console.error(error);
  }
};